import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { InputAdornment, Select, SelectChangeEvent } from '@mui/material';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { orderTypeList, submitComplaint } from '../../Redux/actions/customer';
import { useHistory } from 'react-router-dom';
import Header from '../../Components/Header';
import { useTranslation } from 'react-i18next';
import { MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';


function FeedBack(props:any) {
    const history = useHistory();
    const storeList = useSelector((state: any) => state.store.storeList);
    const orderDetail = useSelector((state: any) => state.menu.orderDetail);
    const customer = useSelector((state: any) => state.customer.customer);
    const orderTypes = useSelector((state: any) => state.customer.orderTypes);
    const [body, setBody] = useState({
        name: "",
        phone_number: '',
        email_address: "",
        store_id: "",
        order_date: '',
        message: "",

    });

    const [disable, setDisable] = useState(true);
    const [phoneError, setPhoneError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [date, setDate] = useState('')
    const [message, setMessage] = useState("");
    const [feedbackType, setFeedbackType] = useState("");
    const [orderType, setOrderType] = useState("");
    const [typeDisable, setTypeDisable] = useState(true);

    const handleChange = (e: any) => {
        setBody({ ...body, [e.target.name]: e.target.value })
        const hasEmptyValue = Object.values(body).some(value => value == '');
        if (hasEmptyValue) {
            setDisable(true)
        }
        else {
            setDisable(false)
        }
        if (e.target.name == "email_address") {
            const emailRegex = /^\S+@\S+\.\S+$/;
            setEmailError(!emailRegex.test(e.target.value));
        }

    }

    const handleEnterPress = (e: any) => {
        if (e.key === 'Enter') {
            if (message.length > 0) {
                handleSubmit();
            }
            else {
                toast.error(t("FEEDBACK_EMPTY"))
            }
        }
    }
    const handleSubmit = () => {
        let body = {
          name: customer?.login_name,
          phone_number: customer?.phone_number,
          email_address: customer?.email_address,
          receipt_number: orderDetail?.order?.order_id,
          store_id: orderDetail?.order?.store_id,
          order_date: props.date,
          message: message,
          type: feedbackType,
          order_type: orderType,
          order_channel: orderDetail?.order?.delivery_status,
        };
        setDisable(true);
        props.submitComplaint(body, history, true);
        props.setFeedbackShow(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        props.orderTypeList()
    }, []);
    useEffect(() => {
        try {
            const dat = props.date ? new Date(props.date).toISOString()?.slice(0, 10) : '';
            setDate(dat)
        } catch (err) {

        }
    }, [])
    const handleFeedback = (e: any) => {
        if (e.target.value.length <= 0) {
            setDisable(true)
        }
        else {
            setDisable(false);
        }
        setMessage(e.target.value);
    }
    const handleType = (e: any) => {
        if (e.target.value.length <= 0) {
            setTypeDisable(true)
        }
        else {
            setTypeDisable(false);
        }
        setFeedbackType(e.target.value);   
    }
    const { t } = useTranslation();

  return (
    <div>
      <section className="">
        <div className="contact-us-container">
          <div className="row">
            <div className="col-md-12">
              <div className="mt-3">
                <h3 className="contact-title">{t("CONTACTDETAILS")}</h3>
                <div className="row">
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={customer?.login_name}
                      onKeyPress={handleEnterPress}
                      name="name"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("FULLNAME")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={customer?.phone_number.split("-")[1]}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className="font-normal number-field kfc-number-field"
                            position="start"
                          >
                            {PHONE_CODE}
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                      onKeyPress={handleEnterPress}
                      helperText={
                        phoneError ? `${t("PHONE_ERROR",{limit:NUMBERS_LIMIT})}` : ""
                      }
                      name="phone_number"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("PHONE_NUMBER")} (${MOBILE_STARS}) *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={customer?.email_address}
                      onKeyPress={handleEnterPress}
                      helperText={emailError ? <>{t("INVALID_EMAIL")}</> : ""}
                      name="email_address"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("EMAIL")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="mt-3">
                <h3 className="contact-title">{t("ABOUT_YOUR_VISIT")}</h3>
                <div className="row">
                
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={orderDetail?.order?.store_name}
                      onKeyPress={handleEnterPress}
                      name="message"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("STORE")}  *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={date}
                      type="date"
                      name="cnic_expire"
                      onKeyPress={handleEnterPress}
                      className="field-style disable-fields"
                      disabled
                      id="filled-basic"
                      label={`${t("DATE")} *`}
                      variant="filled"
                      color="error"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                  </div>
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={orderDetail?.order?.order_id}
                      onKeyPress={handleEnterPress}
                      name="message"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("ORDERID")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <TextField
                      value={orderDetail?.order?.delivery_status}
                      name="order_channel"
                      className="field-style disable-fields kfc-number-field"
                      disabled
                      id="filled-basic"
                      label={`${t("FEEDBACKCHANNEL")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <FormControl
                      className="field-style"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                      {t("FEEDBACK_TYPE")} *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="marital_status"
                        value={feedbackType}
                        onChange={handleType}
                        className="field-style"
                      >
                        <MenuItem value={"Comments"}>
                        {t("COMMENTS")}
                        </MenuItem>
                        <MenuItem value={"Suggestions"}>{t("SUGGESTIONS")}</MenuItem>
                        <MenuItem value={"Questions"}>{t("QUESTIONS")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-12 mt-2">
                    <FormControl
                      className="field-style"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                      {t("FEEDBACK_CATEGORY")} *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="order_type"
                        onChange={(e: SelectChangeEvent) => setOrderType(e.target.value)}
                        className="field-style"
                      >
                        {
                          orderTypes.length > 0 ?
                            orderTypes.map((type: any) => (
                              <MenuItem value={type.type_id}>{type.order_type}</MenuItem>
                            ))
                          : 
                            <MenuItem value={""}>{t("NO_TYPE_FOUND")}</MenuItem>
                        }
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-12 mt-2">
                    <textarea
                      onKeyPress={handleEnterPress}
                      onChange={handleFeedback}
                      
                      className="form-control feetback-comment text-feedback-field"
                      placeholder= {t("HAVESOMEFEEDBACKTOSHARE")}
                      id="exampleFormControlTextarea1"
                      rows={2}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Button
            onClick={handleSubmit}
            disabled={disable || typeDisable || orderType == "" ? true : false}
            className={`w-25 p-3 m-auto d-flex mt-4 mb-3 ${(disable || typeDisable || orderType == "")?"disable-btn":"able-btn"}`}
            variant="contained"
            color="error"
          >
            {t("SUBMIT")}
          </Button>
        </div>
      </section>
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        submitComplaint: function (body: any, history?: any,feedback?:any) {
            dispatch(submitComplaint(body, history,feedback));
        },
        orderTypeList: function (data: any) {
          dispatch(orderTypeList());
        }
    }
}
export default connect(null, mapDispatchToProps)(FeedBack);
